import Vue from 'vue';
import VueResource from 'vue-resource';
import Vuelidate from 'vuelidate';

export default {
    name: 'pagination',
    props: {
        section: {
            type: String,
            default: 'blog'
        },
    },
    data() {
        return {
            currentPage: window.ibJS.currentPage || 1,
            totalPage: window.ibJS.totalPages || 1,
            inputPage: window.ibJS.currentPage || '1'
        }
    },
    computed: {
        baseUrl() {
            const currentPath = window.location.pathname;
        
            switch (this.section) {
                case 'blog': 
                    return currentPath.replace(/\/[\d]+\//g,"/");
                case 'all-questions': 
                    return '/ask-our-specialists/all-questions/';
                default: 
                    return '/';
            }
        },
        disablePrevious() {
            return this.currentPage <= 1;
        },
        disableNext() {
            return this.currentPage >= this.totalPage;
        },
        maxDigits() {
            return String(this.totalPage).length;
        }
    },
    methods: {
        goToPreviousPage() {
            if(this.section == 'search-results') {
                this.searchResultsChangePage(this.currentPage - 1);
            } else {
                if(!this.disablePrevious) {
                    window.location.href = (this.baseUrl + (this.currentPage - 1) + '/');
                }
            }
        },
        goToNextPage() {
            if(this.section == 'search-results') {
                this.searchResultsChangePage(this.currentPage + 1);
            } else {
                if(!this.disableNext) {
                    window.location.href = (this.baseUrl + (this.currentPage + 1) + '/');
                }
            }
        },
        handleInput(event) {
            if(event.keyCode == 13) {
                if(this.inputPage >= 1 && this.inputPage <= this.totalPage) {
                    if(this.section == 'search-results') {
                        this.searchResultsChangePage(this.inputPage);
                    } else {
                        window.location.href = this.baseUrl + this.inputPage + '/';
                    }
                }
            } else {
                this.inputPage = this.inputPage?.replace(/\D+/g, '');
            }
        },
        searchResultsChangePage(page) {
            var $query = window.ibJS.searchResults.query;
            var data = {
                "query": $query,
                "page": page
            };
            var $siteSearchMainForm = document.querySelector("#siteSearchMain");
            var $inputField = document.querySelector("#siteSearchMain .search-input");
            var $pageField = document.querySelector("#search-page");
            $inputField.value = data.query;
            $pageField.value = data.page;
            $siteSearchMainForm.action = window.globalLanguage.searchUrl;
            $siteSearchMainForm.submit();
        }
    }
}